module.exports = __webpack_public_path__ + "static/media/BannerRegistroEN.36bcddfc.jpg";